/* Auth module */
export const LOGIN = 'login';
export const LOGOUT = 'logout';

/* Dashboard */
export const FETCH_DASHBOARD_DATA = 'fetchDashboardData';
